import React__default from 'react';
import { Wrapper } from './Default.styles.js';

var CountdownTimer = function CountdownTimer(_ref) {
  var _hours$toString, _minutes$toString;
  var timeLeft = _ref.timeLeft;
  var days = timeLeft.days,
    hours = timeLeft.hours,
    minutes = timeLeft.minutes;
  var hoursWithLeadingZero = hours === null || hours === void 0 || (_hours$toString = hours.toString()) === null || _hours$toString === void 0 ? void 0 : _hours$toString.padStart(2, '0');
  var minutesWithLeadingZero = minutes === null || minutes === void 0 || (_minutes$toString = minutes.toString()) === null || _minutes$toString === void 0 ? void 0 : _minutes$toString.padStart(2, '0');
  return /*#__PURE__*/React__default.createElement(Wrapper, null, days, ":", hoursWithLeadingZero, ":", minutesWithLeadingZero);
};
var Default = CountdownTimer;

export { Default as default };
//# sourceMappingURL=index.js.map
